// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"2cf3ef8c","306":"2cf3ef8c","383":"2cf3ef8c","734":"2cf3ef8c","770":"2cf3ef8c","975":"d897af9c"}[chunkId] + ".chunk.css";
};